module.exports = __webpack_public_path__ + "static/media/construct.91a18993.gif";